import React, { createContext, useState } from 'react';

export const UserContext = createContext();

const initialState = {
  user: {
    signedIn: false,
    greeting: '',
    basket: { items: 0 },
    shopperId: '',
  },
};

export const UserContextProvider = props => {
  const [userState, updateUserState] = useState(initialState);

  return (
    <UserContext.Provider value={{ userState, updateUserState }}>
      {props.children}
    </UserContext.Provider>
  );
};
